import { API } from "aws-amplify";
import { OffLineAPI } from '../offline-auth/api';

var _API = process.env.REACT_APP_isOffline === "true" ? OffLineAPI : API;

export function loadChat (id) {
    return _API.get("appointment", `/chatlist?appointmentId=${id}`);
}

export function saveChat (body) {
    return _API.post("appointment", `/chat`, {body});
}